import * as Sentry from '@sentry/browser'
import FP from '@fingerprintjs/fingerprintjs-pro'
import { FP_ACTIVE, FP_CLIENT_TOKEN, FP_ENDPOINT, REGION } from '@constants'

export const callFingerPrinting = async ({
  isSelfAssessment,
  signature,
  request_id
}) => {
  const entity = isSelfAssessment ? 'survey-self-assessment' : 'survey-reference'

  const isActive = FP_ACTIVE === true || FP_ACTIVE === 'true'
  if (isActive && sessionStorage.getItem(`fps-${entity}`) === null) {
    const requestMetadata = {
      entity: entity,
      uid: signature,
      request_id: request_id
    }

    if (!isSelfAssessment) {
      requestMetadata.reference_id = signature
    }

    let retries = 0
    let fpSuccess = false
    let fpError = ''
    while (retries < 3 && !fpSuccess) {
      try {
        const fp = await FP.load({
          apiKey: FP_CLIENT_TOKEN,
          endpoint: FP_ENDPOINT,
          region: REGION,
          scriptUrlPattern: `${FP_ENDPOINT}/web/v3/${FP_CLIENT_TOKEN}/loader_v3.6.1.js`
        })
        const response = await fp.get({
          extendedResult: true,
          tag: requestMetadata
        })
        if (response.visitorId) {
          fpSuccess = true
          sessionStorage.setItem(`fps-${entity}`, true)
        }
      } catch (e) {
        fpError = e
        retries++
      }
    }
    if (retries > 0) {
      Sentry.captureMessage('Fingerprint connection error: ' + fpError, 'warning')
    }
  }
}
